import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import { LanguageProvider } from './v3/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import V3Home from './v3/pages/V3Home';
import V3LeadershipDevelopment from './v3/pages/V3LeadershipDevelopment';
import V3HyperlocalPlatform from './v3/pages/V3HyperlocalPlatform';
import V3About from './v3/pages/V3About';
import V3SponsorProgram from './v3/pages/V3SponsorProgram';
import V3Apply from './v3/pages/V3Apply';
import V3Blog from './v3/pages/V3Blog';
import V3BlogPost from './v3/pages/V3BlogPost';
import V3LegalPage from './v3/pages/V3LegalPage';
import ScrollToTop from './v3/components/ScrollToTop';
import RequestDemo from './pages/RequestDemo';
import './App.css';

const V3_ROUTES = new Set([
  '/',
  '/leadership-development',
  '/hyperlocal-platform',
  '/about',
  '/sponsor-a-program',
  '/apply',
  '/blog',
  '/privacy-policy',
  '/terms-of-use',
  '/cookie-policy',
]);

function AppLayout() {
  const location = useLocation();
  const isV3 = V3_ROUTES.has(location.pathname) || location.pathname.startsWith('/blog/');

  // V3 UI is always light — prevent dark-theme vars from washing out body text
  useEffect(() => {
    if (isV3) {
      document.documentElement.setAttribute('data-theme', 'light');
    }
  }, [isV3]);

  return (
    <div className={`App ${isV3 ? 'v3-mode' : ''}`}>
      {!isV3 && <Header />}
      <main className={isV3 ? 'v3-main' : 'main-content'}>
        <Routes>
          <Route path="/" element={<V3Home />} />
          <Route path="/leadership-development" element={<V3LeadershipDevelopment />} />
          <Route path="/hyperlocal-platform" element={<V3HyperlocalPlatform />} />
          <Route path="/about" element={<V3About />} />
          <Route path="/sponsor-a-program" element={<V3SponsorProgram />} />
          <Route path="/apply" element={<V3Apply />} />
          <Route path="/blog" element={<V3Blog />} />
          <Route path="/blog/:slug" element={<V3BlogPost />} />
          <Route path="/request-a-demo" element={<RequestDemo />} />
          <Route path="/privacy-policy" element={<V3LegalPage pageKey="privacy" />} />
          <Route path="/terms-of-use" element={<V3LegalPage pageKey="terms" />} />
          <Route path="/cookie-policy" element={<V3LegalPage pageKey="cookie" />} />
          {/* Legacy route redirects */}
          <Route path="/sponsor-panchayat" element={<Navigate to="/sponsor-a-program" replace />} />
          <Route path="/leadership-pathways" element={<Navigate to="/leadership-development" replace />} />
          <Route path="/leadership-pathways/apply" element={<Navigate to="/apply#apply-form" replace />} />
          <Route path="/partner" element={<Navigate to="/sponsor-a-program" replace />} />
          <Route path="/partner/*" element={<Navigate to="/sponsor-a-program" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!isV3 && <Footer />}
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <ScrollToTop />
          <AppLayout />
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
